var render, staticRenderFns
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Jenkins\\workspace\\Rewards Prod - All Testing\\SarnovaReward\\SarnovaReward-Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40e6074e', component.options)
    } else {
      api.reload('40e6074e', component.options)
    }
    
  }
}
component.options.__file = "src/main/webapp/resources/components/login/Login.vue"
export default component.exports